var _circle, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExchangeThreeIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 30,
    r: 30,
    fill: "#E3E9EC"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_70_637)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.1665 32.9167C39.4745 32.917 39.7708 33.0349 39.9947 33.2464C40.2186 33.4578 40.3534 33.7467 40.3715 34.0542C40.3895 34.3616 40.2895 34.6644 40.0918 34.9005C39.8941 35.1367 39.6137 35.2885 39.3079 35.3249L39.1665 35.3333H22.7501L25.5208 38.104C25.7376 38.3215 25.8634 38.6133 25.8727 38.9201C25.8821 39.227 25.7743 39.5259 25.5713 39.7562C25.3682 39.9864 25.0852 40.1308 24.7796 40.1599C24.4739 40.189 24.1687 40.1007 23.9258 39.9129L23.8123 39.8126L19.1843 35.1847C18.3808 34.3824 18.8955 33.0302 19.9855 32.9239L20.1244 32.9167H39.1665ZM33.4789 21.1874C33.687 20.9793 33.9638 20.8543 34.2575 20.8359C34.5511 20.8174 34.8414 20.9067 35.0739 21.0871L35.1875 21.1874L39.8154 25.8153C40.619 26.6176 40.1042 27.9697 39.0143 28.0761L38.8753 28.0833H19.8332C19.5252 28.083 19.229 27.9651 19.0051 27.7536C18.7811 27.5422 18.6463 27.2533 18.6283 26.9458C18.6103 26.6384 18.7103 26.3356 18.908 26.0994C19.1056 25.8633 19.386 25.7115 19.6918 25.6751L19.8332 25.6667H36.2496L33.4789 22.896C33.2524 22.6694 33.1251 22.3621 33.1251 22.0417C33.1251 21.7213 33.2524 21.414 33.4789 21.1874Z",
    fill: "#00525D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_70_637"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 29,
    height: 29,
    fill: "white",
    transform: "translate(15 16)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExchangeThreeIcon);
export default __webpack_public_path__ + "static/media/exchange-three-icon.56ebbe0b3b53d3e04665a45578b08f82.svg";
export { ForwardRef as ReactComponent };